import React from 'react';

import { Col, Row, Button, Layout, Breadcrumb, Steps } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getDepositosPorRangoFecha from '../../../graphql/querys/ventas/getDepositosPorRangoFecha.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import FormRangoFechas from './FormRangoFechas';
import TablaMostrarDepositos from './TablaMostrarDepositos';
import { descargarCSV } from '../../administracion/funciones/descargarCSV';
import { imprimirReporte } from '../../common/impresion/ImprimirDepositosPorRango';

@graphql(getUsuario)
class DepositosPorRango extends React.Component {
  state = {
    depositos: [],
    fechaInicio: '',
    fechaFin: '',
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  buscar = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    // console.log("Buscando....");
    // console.log(fechaInicio);
    // console.log(fechaFin);

    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getDepositosPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        let colDepositos = res.data.getDepositosPorRangoFecha;

        let depositos = _.map(colDepositos, deposito => {
          return {
            ...deposito,
            key: deposito._id,
            fecha: moment(deposito.fecha).format('DD/MM/YYYY'),
          };
        });

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          depositos: depositos,
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          step: 1,
          loading: false,
        });
      });
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
    });
  };

  onDescargar = () => {
    let data = _.map(this.state.depositos, deposito => {
      if (deposito.tipo === 'deposito') {
        return {
          tipo: deposito.tipo,
          fecha: deposito.fecha,
          fechaInicioPeriodo: moment(deposito.fechaPeriodoInicio).format(
            'DD/MM/YYYY'
          ),
          fechaFinPeriodo: moment(deposito.fechaPeriodoFin).format(
            'DD/MM/YYYY'
          ),
          numeroBoleta: deposito.numBoletaDeposito,
          banco: deposito.sucursal.nombre,
        };
      } else {
        return {
          tipo: deposito.tipo,
          fecha: deposito.fecha,
          fechaInicioPeriodo: moment(deposito.fechaPeriodoInicio).format(
            'DD/MM/YYYY'
          ),
          fechaFinPeriodo: moment(deposito.fechaPeriodoFin).format(
            'DD/MM/YYYY'
          ),
          numeroBoleta: deposito.numBoletaDeposito,
          banco: deposito.nombreBancoTransferencia,
        };
      }
    });

    data = [...data];
    descargarCSV(
      [
        'TIPO',
        'FECHA DEPOSITO',
        'FECHA INICIO PERIODO',
        'FECHA FIN PERIODO',
        'Nº BOLETA',
        'BANCO',
      ],
      data,
      `ReporteDepositosPorFecha-${moment(this.state.fechaInicio).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFin).format('DD/MM/YYYY')}.csv`
    );
  };

  render() {
    const { data } = this.props;
    if (data.loading || this.state.loading) {
      return <Loading />;
    }

    if (!data.getUsuario) {
      return null;
    }
    const { Step } = Steps;
    let { step } = this.state;
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');
    let montoTotal = _.sumBy(this.state.depositos, o => {
      return o.importe;
    });
    let fInicio = moment(this.state.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.state.fechaFin).format('DD/MM/YYYY');

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Depositos Por Fecha</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Administración General</h1>
          <Steps className="stepsFormularios" current={step}>
            <Step title="Seleccionar Fechas" />
            <Step title="Visualizar Resultados" />
          </Steps>
          {step == 0 && (
            <FormRangoFechas buscar={this.buscar} buscarSQL={false} />
          )}
          {step == 1 && (
            <div>
              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Organismo: {this.state.nombreOrganismo}
              </h2>

              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                Reporte para el rango de fechas de: {fInicio} - {fFin}
              </h3>

              <Row>
                <Col span={8} offset={8}>
                  <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                    Fecha de generacion: {fGeneracion}
                  </h5>
                </Col>
                <Col span={6}>
                  <Button type="primary" onClick={() => this.onDescargar()}>
                    <Icons.DownloadOutlined />
                    Descargar Reporte
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col span={16} offset={4}>
                  <TablaMostrarDepositos
                    organismo={this.state.nombreOrganismo}
                    fechaInicio={this.state.fechaInicio}
                    fechaFin={this.state.fechaFin}
                    data={this.state.depositos}
                    onCancelar={this.onCancelar}
                  />
                </Col>
              </Row>
              <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                Monto Total:
                {montoTotal.toLocaleString('es-AR', {
                  style: 'currency',
                  currency: 'ARS',
                })}
              </h3>
              <Row>
                <Col span={8} offset={10}>
                  <Button
                    type="primary"
                    // style={{ marginLeft: '20%' }}
                    onClick={() =>
                      imprimirReporte({
                        nombreOrganismo: this.state.nombreOrganismo,
                        fechaGeneracion: fGeneracion,
                        fechaInicio: moment(this.state.fechaInicio).format(
                          'DD/MM/YYYY'
                        ),
                        fechaFin: moment(this.state.fechaFin).format(
                          'DD/MM/YYYY'
                        ),
                        depositos: this.state.depositos,
                        montoTotal: montoTotal,
                      })
                    }
                  >
                    Imprimir Datos
                  </Button>
                  <Button
                    style={{ marginLeft: 10 }}
                    type="danger"
                    onClick={() => this.onCancelar()}
                  >
                    Atras
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(DepositosPorRango);
